import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-regional-contacts__inner" }
const _hoisted_3 = { class: "c-regional-contacts__list" }
const _hoisted_4 = ["aria-expanded", "aria-controls", "onClick"]
const _hoisted_5 = { class: "c-regional-contacts__summary" }
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "c-regional-contacts__detail"
}
const _hoisted_8 = {
  key: 1,
  class: "c-regional-contacts__detail"
}
const _hoisted_9 = ["href"]

import { computed, ref } from 'vue';
import { Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type {
  RegionalContactItemFields,
  RegionalContactsProps,
} from '@/types/components/RegionalContacts';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

interface NormalizedContact extends ScItem<RegionalContactItemFields> {
  fields: RegionalContactItemFields;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegionalContacts',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);
const activeIndex = ref(0);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-regional-contacts'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const rawContacts = computed<ScItem<RegionalContactItemFields>[]>(() => {
  const contactItems = utils.sc.getFieldObj(fields.value, 'contacts');
  return Array.isArray(contactItems) ? contactItems : [];
});

const contacts = computed<NormalizedContact[]>(() =>
  rawContacts.value.filter((item): item is NormalizedContact => Boolean(item.fields))
);

const toggleContact = (index: number) => {
  activeIndex.value = activeIndex.value === index ? -1 : index;
};

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && contacts.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [0, 24],
          "tablet-default-grid": [0, 16],
          "mobile-default-grid": [0, 16]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_JssRichText, {
                field: fields.value?.title,
                tag: "h2"
              }, null, 8, ["field"]),
              (fields.value.subtitle?.value)
                ? (_openBlock(), _createBlock(_unref(JssText), {
                    key: 0,
                    class: "c-regional-contacts__subtitle",
                    field: fields.value.subtitle,
                    tag: "p"
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value, (contact, index) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: contact.id,
                    class: _normalizeClass(["c-regional-contacts__item", { 'is-active': activeIndex.value === index }])
                  }, [
                    _createElementVNode("button", {
                      class: "c-regional-contacts__trigger",
                      type: "button",
                      "aria-expanded": activeIndex.value === index,
                      "aria-controls": `regional-contact-${contact.id}`,
                      onClick: ($event: any) => (toggleContact(index))
                    }, [
                      _createElementVNode("span", _hoisted_5, [
                        (contact.fields.region?.value)
                          ? (_openBlock(), _createBlock(_unref(JssText), {
                              key: 0,
                              class: "c-regional-contacts__region",
                              field: contact.fields.region,
                              tag: "span"
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (contact.fields.officeName?.value)
                          ? (_openBlock(), _createBlock(_unref(JssText), {
                              key: 1,
                              class: "c-regional-contacts__office",
                              field: contact.fields.officeName,
                              tag: "span"
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[0] || (_cache[0] = _createElementVNode("span", {
                        class: "c-regional-contacts__chevron",
                        "aria-hidden": "true"
                      }, null, -1))
                    ], 8, _hoisted_4),
                    _createElementVNode("div", {
                      id: `regional-contact-${contact.id}`,
                      class: "c-regional-contacts__panel"
                    }, [
                      (contact.fields.address?.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(contact.fields.address.value), 1))
                        : _createCommentVNode("", true),
                      (contact.fields.phone?.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(contact.fields.phone.value), 1))
                        : _createCommentVNode("", true),
                      (contact.fields.email?.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            class: "c-regional-contacts__email",
                            href: `mailto:${contact.fields.email.value}`
                          }, _toDisplayString(contact.fields.email.value), 9, _hoisted_9))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_6)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})